import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import HomePage from './components/homepage';
import DiscoveryPage from './components/discovery';
import OutreachPage from './components/outreach';


const App: React.FC = () => (
  <Routes>
    <Route path="/" element={<Layout />}>
      <Route index element={<HomePage />} />
      <Route path="discovery" element={<DiscoveryPage />} />
      <Route path="outreach" element={<OutreachPage />} />
    </Route>
  </Routes>
);

export default App;
